import { utils, writeFile } from "xlsx";
import axiosInstance from "../../../../../http-common";

const backend_url = process.env.REACT_APP_BACKEND_MAIN_URL;

export const download_excel_data = (value) => {
  const category = value === 0 ? "CB" : value === 1 ? "INTM" : "FP";
  const api = `${backend_url}/v1/qc/backlog_po/${category}/`;
  // const a = React.createElement('a', { id: `${category}_excel_file_download`, href: api, target: "_blank" });
  const a = document.createElement("a");
  a.target = "_blank";
  a.href = api;
  a.id = `${category}_excel_file_download`;
  console.log(a);
  a.click();
};

export const generateExcel = async (category) => {

  try {
    // const response = await axiosInstance.get(`/v1/qc/excel_download/${category}/`);
    // const data = await response.data;

    // const wb = utils.book_new();
    // const ws = utils.json_to_sheet(data.data);

    // utils.book_append_sheet(wb, ws, 'DataSheet');

    // const client_id = localStorage.getItem("client_id");

    // // const blob = 
    // writeFile(wb, `${client_id}-${category}_data.xlsx`, { bookType: 'xlsx', type: 'blob' });

    // Adjust the request to receive a blob (binary data)
    const response = await axiosInstance.get(`/v1/qc/excel_download/${category}/`, {
      responseType: 'blob'
    });

    // Get the client_id from localStorage
    const client_id = localStorage.getItem("client_id");

    // Create a URL for the blob
    const url = window.URL.createObjectURL(new Blob([response.data]));

    // Create a temporary link element
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `${client_id}-${category}_data.xlsx`);

    // Append the link to the body and trigger the download
    document.body.appendChild(link);
    link.click();

    // Clean up
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);

    // const url = URL.createObjectURL(blob);
    // const link = document.createElement('a');
    // link.href = url;
    // link.download = 'data.xlsx';
    // link.click();

    // URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Error:', error);
  }
};